import React from 'react';
import DatePicker from 'material-ui/DatePicker';
import DateTimeFormat from './dateTimeFormat';


export default class CustomDatePicker extends React.Component {

    render() {
        let timestamp = Date.parse(this.props.stringValue);
        let d = new Date();
        if (isNaN(timestamp) === false) {
            d = new Date(timestamp);
        }
        return (
            <DatePicker
                className={this.props.className}
                floatingLabelText={this.props.floatingLabelText}
                hintText={this.props.hintText}
                DateTimeFormat={DateTimeFormat}
                okLabel="OK"
                value={d}
                cancelLabel="Annuler"
                locale="fr"
                fullWidth={true}
                onChange={this.props.onChange}
                disabled={this.props.disabled}
            />);
    }
}






// WEBPACK FOOTER //
// ./src/components/shared/utils/CustomDatePicker.js